export default {
  width: 31,
  height: 24,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3h-5a1 1 0 1 1 0-2h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 15a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6zm3-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6z"/>
  `
}
